export const updateGame = 'updateGame';
// const updateGame = { type: 'updateGame', payload: 'Cricket' }

export default updateGame;
